<template>
  <div>
    <div class="mb-5">
      <h1>This store is disabled or you are not store/support admin user</h1>
      <p>
        Please  <a id="qsLogoutBtn" href="#" class @click.prevent="logout">Log out</a> and then contact superadmin for help.
      </p>

    </div>
  </div>
</template>
<script lang="ts" setup>

import { useAuth0 } from "@auth0/auth0-vue";
const auth0 = useAuth0();
function logout() {
  sessionStorage.removeItem('vuex');
  localStorage.clear();
  auth0.logout({
    returnTo: window.location.origin
  });
}
</script>

